import { render } from "./JuzgadosCRUD.vue?vue&type=template&id=d22c8b3c"
import script from "./JuzgadosCRUD.vue?vue&type=script&lang=js"
export * from "./JuzgadosCRUD.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__